import styled from 'styled-components';
export var CarouselWrapper = styled.div.withConfig({
  componentId: "sc-q2pxv2-0"
})(["overflow:hidden;position:relative;height:", "px;transition:height 0.2s ease-in;"], function (_ref) {
  var height = _ref.height;
  return height;
});